import { Flex } from 'reflexbox';
import { QuestionCircleIcon, Tooltip } from 'boss-ui';

export default function SwitchHelpTooltip({ tooltip_id, text }) {
  return (
    <Flex
      data-tip
      data-for={tooltip_id}
    >
      <QuestionCircleIcon />
      <Tooltip id={tooltip_id} place="right">
        {text}
      </Tooltip>
    </Flex>
  );
}